<template>
    <div v-show="isModalVisible" class="mm_body">
        <div class="modal-mask" @click="close">
            <div class="modal-container" @click.stop>
                <!-- Modal body -->
                <div class="modal-body" id="modalContent">
                    <div class="col-xs-12">
                        <button type="button" class="close" data-dismiss="modal" @click="close">&times;</button>
                        <h1 class="inner-page mm-login-text">Reset Password</h1>
                        <hr>
                        <p class="margin-bottom-30">
                            Please provide the e-mail address associated with your account. The link and information to reset your password will be sent to your e-mail shortly.
                        </p>
                        <div v-show="login_errors" class="validate-warning-msg-login">{{ login_errors }}</div>
                        <form @submit.prevent="onSubmit">
                            <div class="form-group col-sm-10">
                                <input 
                                    type="email"
                                    name="email address"
                                    id="email_addr"
                                    ref="email_addr"
                                    v-validate="'required|email'"
                                    v-model="email_addr"
                                    class="form-control" 
                                    placeholder="*Email">
                                    <div v-show="verrors.has('email address')" class="validate-warning-msg">{{ verrors.first('email address') }}</div>
                            </div>
                            <div style="clear: both;"></div>	
                            <div class="text-center pad-20">
                                <button type="submit" class="btn btn-lg btn-blue text-bebas-btn text-center border-radius-20">{{submit_value}}</button>
                            </div>
                        </form>
                        <p class="mm-email-hint">If you don't have an e-mail or don't remember the e-mail for your account, contact your account administrator.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.pad-20 {padding: 20px;}
@import 'https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@700&display=swap';
.get-started-btn, .text-bebas-btn {
    font-family: 'Roboto Condensed', sans-serif;
}
.mm-login-text {
    font-family: 'Roboto Condensed', sans-serif;
}
.mm_body {
    font-size: 20px !important;
    color: #939393;
}
.margin-bottom-30 {margin-bottom: 30px;}
/* Form input css start */
.form-control {height: 54px;}
.form-control {font-size: 18px; color: #000; background: #F5F5F5;}
.validate-warning-msg {
    text-align: left;
    font-size: 16px;
}
.form-group { margin-left: 90px; }
/* Form input css stop */
/* heading css start */
/* heading css start */
.h1, h1 {
    font-size: 28px !important;
}
.h1, .h2, .h3, h1, h2, h3 {
    margin-top: 20px;
    margin-bottom: 10px;
}
.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
}
/* heading css stop */
hr {
    border-top: 1px solid #e3e3e3;
    margin-top: 20px;
    margin-bottom: 20px;
}
/* heading css stop */
/* button css start */
.btn-lg {padding: 0px 50px;}
.btn-blue {background-color: #00ACEE !important; color: #fff;}
.btn {border-radius: 8px; border: none; font-size: 22px !important; font-weight: bold; font-style:  normal;}
.btn:hover, .btn:focus {color: #fff !important; text-decoration: underline; outline: 0 !important;}
/* button css stop */
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}
.modal-container {
    padding: 10px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    text-align: left;
    border: none;
    font-family: "proxima-nova" , Arial, verdana !important;
}
.modal-body {
    margin: 0 20px;
    padding: 0px;
}
@media(max-width:560px) {
  .modal-body {
      margin: 0px;
      padding: 0px;
      height: 100%;
  }
  .form-group { margin-left: 0px; }
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
  border: 0px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.modal-footer {
  border-top: none;
}
.inner-page {
    font-size: 28px;
    font-weight: normal;
}
.btn-white:hover {
    color: #000 !important;    
}
.btn-white {
    background-color: #efefef !important;
}
#modalContent {
    color: #707070;
}
.mm-email-hint {
    margin: 20px 0;
    font-size: 12px;
}
@media (min-width: 1024px){
    .modal-container {
        width: 800px;
        margin: 180px auto 0;
    }
}
@media(max-width: 991px) {
    .modal-container {
        width: 96%;
        padding: 20px 20px;
        margin: 90px auto;
    }
    .form-group {
        margin-left: 0px;
    }
}
</style>
<script>
import axios from 'axios';
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import router from '../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible'],
    data: function () {
        return {
            submit_value: 'Send',
            email_addr: '',
            login_errors: '',
        }
    },
    methods: {
        close() {
            this.$validator.reset();
            this.$emit('close');
        },
        onSubmit () {
            this.$validator.validateAll().then((result) => {
                if(!result){
                    return;
                }
                this.forgotpassword();
            }).catch(() => {
                // catches the error;
            });
        },
        forgotpassword: function() {
            this.submit_value = "Please Wait ..."
            let email = this.email_addr;
            axios('/custom/forgot_password/' + email,
                {
                method: 'GET',
                }
            )
            .then(resp => {
                this.email_addr = '';
                this.submit_value = "Send";
                this.close();
                this.$parent.openSuccessModal();
            })
            .catch(error => {
                this.submit_value = "Send"
                this.login_errors = error.response.data.message;
            })
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/mm_forgotpassword.vue